import React, { useState } from 'react';
import locationService from '../../utils/location-service';
import './LocationButton.scss';

const LocationButton = ({ onLocationDetected, onError, disabled = false, className = '' }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLocationClick = async () => {
    if (disabled || loading) return;

    setLoading(true);
    setError('');

    try {
      const result = await locationService.getCurrentLocationAddress();
      
      if (result.success) {
        onLocationDetected(result.address, result.message);
      } else {
        setError(result.error);
        if (onError) {
          onError(result.error);
        }
      }
    } catch (error) {
      const errorMessage = 'Failed to get location. Please try again.';
      setError(errorMessage);
      if (onError) {
        onError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  // Don't render if geolocation is not supported
  if (!locationService.isGeolocationSupported()) {
    return null;
  }

  return (
    <div className={`location-button-container ${className}`}>
      <button
        type="button"
        className={`location-button ${loading ? 'loading' : ''} ${error ? 'error' : ''}`}
        onClick={handleLocationClick}
        disabled={disabled || loading}
        title="Use your current location to auto-fill address"
      >
        <div className="location-button-content">
          {loading ? (
            <>
              <div className="spinner"></div>
              <span>Getting location...</span>
            </>
          ) : (
            <>
              <svg className="location-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <circle cx={12} cy={10} r={3} />
              </svg>
              <span>Use Current Location</span>
            </>
          )}
        </div>
      </button>
      
      {error && (
        <div className="location-error">
          <small>{error}</small>
        </div>
      )}
    </div>
  );
};

export default LocationButton;